import { Option } from '../../types/option'

type TabsProps = {
  tab: string
  tabs: Option[]
  onChange: (value: string) => void
  className?: string
  disabled?: boolean
}

export const Tabs = ({
  tab,
  tabs,
  onChange,
  className,
  disabled = false,
}: TabsProps) => {
  return (
    <div className={`tabs ${className ?? ''}`}>
      {tabs.map(option => {
        return (
          <button
            key={option.value}
            type="button"
            className={tab === option.value ? 'on' : ''}
            disabled={disabled}
            aria-label={option.label}
            onClick={() => onChange(option.value)}
          >
            {option.mobileLabel ? (
              <>
                <span className="d-none d-sm-inline">{option.label}</span>
                <span className="d-sm-none">{option.mobileLabel}</span>
              </>
            ) : (
              option.label
            )}
          </button>
        )
      })}
    </div>
  )
}
